import { App } from 'vue'; // Vue 3 uchun
import ElementPlus from 'element-plus';
import ru from 'element-plus/es/locale/lang/ru'; // Rus tilini ulash

import 'element-plus/dist/index.css'; // Element Plus CSS import qilish
{ App }
export default (app) => {
    app.use(ElementPlus, {
        locale: ru, // Rus tilini qo'llash
    });
};
